import { useMutation, useQueryClient } from '@tanstack/react-query';
import { type MutationOptions, gqlFetcher } from '../fetcher';
import { CreateParticipantFieldTemplate } from '../mutations/createParticipantFieldTemplate.mutation';
import type {
  CreateParticipantFieldTemplateMutation,
  CreateParticipantFieldTemplateMutationVariables,
} from '../types';

export const useCreateParticipantFieldTemplateMutation = (
  options?: MutationOptions<
    CreateParticipantFieldTemplateMutation,
    CreateParticipantFieldTemplateMutationVariables
  >,
) => {
  const queryClient = useQueryClient();

  return useMutation(gqlFetcher(CreateParticipantFieldTemplate), {
    ...options,
    onSettled: async (resp, error, variables, ctx) => {
      await options?.onSettled?.(resp, error, variables, ctx);

      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey.includes('participantFieldGroupTemplate'),
      });
    },
  });
};
